// FistOS control protocol — approval broker round-trip (AGENTS.md §5.3).
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_action } from "./action_pb.js";
/**
 * Describes the file approval.proto.
 */
export const file_approval = /*@__PURE__*/ fileDesc("Cg5hcHByb3ZhbC5wcm90bxIJZmlzdG9zLnYxIsYBCg9BcHByb3ZhbFJlcXVlc3QSEwoLYXBwcm92YWxfaWQYASABKAkSDwoHdGFza19pZBgCIAEoCRIhCgZhY3Rpb24YAyABKAsyES5maXN0b3MudjEuQWN0aW9uEi0KCGNhdGVnb3J5GAQgASgOMhsuZmlzdG9zLnYxLkFwcHJvdmFsQ2F0ZWdvcnkSDgoGcmVhc29uGAUgASgJEhQKDHBhY2thZ2VfbmFtZRgGIAEoCRIVCg1leHBpcmVzX2F0X21zGAcgASgDIkcKEEFwcHJvdmFsUmVzcG9uc2USEwoLYXBwcm92YWxfaWQYASABKAkSEAoIYXBwcm92ZWQYAiABKAgSDAoEbm90ZRgDIAEoCSrpAwoQQXBwcm92YWxDYXRlZ29yeRIhCh1BUFBST1ZBTF9DQVRFR09SWV9VTlNQRUNJRklFRBAAEh0KGUFQUFJPVkFMX0NBVEVHT1JZX1BBWU1FTlQQARIdChlBUFBST1ZBTF9DQVRFR09SWV9BQ0NPVU5UEAISIwofQVBQUk9WQUxfQ0FURUdPUllfRkFDVE9SWV9SRVNFVBADEicKI0FQUFJPVkFMX0NBVEVHT1JZX1VOS05PV05fUkVDSVBJRU5UEAQSIwofQVBQUk9WQUxfQ0FURUdPUllfU0VDVVJFX1NDUkVFThAFEhoKFkFQUFJPVkFMX0NBVEVHT1JZX0NBTEwQBhIdChlBUFBST1ZBTF9DQVRFR09SWV9NRVNTQUdFEAcSJQohQVBQUk9WQUxfQ0FURUdPUllfU1lTVEVNX1NFVFRJTkdTEAgSHQoZQVBQUk9WQUxfQ0FURUdPUllfSU5TVEFMTBAJEhwKGEFQUFJPVkFMX0NBVEVHT1JZX0NBTUVSQRAKEiAKHEFQUFJPVkFMX0NBVEVHT1JZX0NBTExfQVVESU8QCxIbChdBUFBST1ZBTF9DQVRFR09SWV9PVEhFUhAMEiMKH0FQUFJPVkFMX0NBVEVHT1JZX1NDUkVFTl9TVFJFQU0QDWIGcHJvdG8z", [file_action]);
/**
 * Describes the message fistos.v1.ApprovalRequest.
 * Use `create(ApprovalRequestSchema)` to create a new message.
 */
export const ApprovalRequestSchema = /*@__PURE__*/ messageDesc(file_approval, 0);
/**
 * Describes the message fistos.v1.ApprovalResponse.
 * Use `create(ApprovalResponseSchema)` to create a new message.
 */
export const ApprovalResponseSchema = /*@__PURE__*/ messageDesc(file_approval, 1);
/**
 * Why the broker escalated an action. Mirrors policy/rules.rs.
 *
 * @generated from enum fistos.v1.ApprovalCategory
 */
export var ApprovalCategory;
(function (ApprovalCategory) {
    /**
     * @generated from enum value: APPROVAL_CATEGORY_UNSPECIFIED = 0;
     */
    ApprovalCategory[ApprovalCategory["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: APPROVAL_CATEGORY_PAYMENT = 1;
     */
    ApprovalCategory[ApprovalCategory["PAYMENT"] = 1] = "PAYMENT";
    /**
     * @generated from enum value: APPROVAL_CATEGORY_ACCOUNT = 2;
     */
    ApprovalCategory[ApprovalCategory["ACCOUNT"] = 2] = "ACCOUNT";
    /**
     * @generated from enum value: APPROVAL_CATEGORY_FACTORY_RESET = 3;
     */
    ApprovalCategory[ApprovalCategory["FACTORY_RESET"] = 3] = "FACTORY_RESET";
    /**
     * @generated from enum value: APPROVAL_CATEGORY_UNKNOWN_RECIPIENT = 4;
     */
    ApprovalCategory[ApprovalCategory["UNKNOWN_RECIPIENT"] = 4] = "UNKNOWN_RECIPIENT";
    /**
     * @generated from enum value: APPROVAL_CATEGORY_SECURE_SCREEN = 5;
     */
    ApprovalCategory[ApprovalCategory["SECURE_SCREEN"] = 5] = "SECURE_SCREEN";
    /**
     * @generated from enum value: APPROVAL_CATEGORY_CALL = 6;
     */
    ApprovalCategory[ApprovalCategory["CALL"] = 6] = "CALL";
    /**
     * @generated from enum value: APPROVAL_CATEGORY_MESSAGE = 7;
     */
    ApprovalCategory[ApprovalCategory["MESSAGE"] = 7] = "MESSAGE";
    /**
     * @generated from enum value: APPROVAL_CATEGORY_SYSTEM_SETTINGS = 8;
     */
    ApprovalCategory[ApprovalCategory["SYSTEM_SETTINGS"] = 8] = "SYSTEM_SETTINGS";
    /**
     * @generated from enum value: APPROVAL_CATEGORY_INSTALL = 9;
     */
    ApprovalCategory[ApprovalCategory["INSTALL"] = 9] = "INSTALL";
    /**
     * @generated from enum value: APPROVAL_CATEGORY_CAMERA = 10;
     */
    ApprovalCategory[ApprovalCategory["CAMERA"] = 10] = "CAMERA";
    /**
     * @generated from enum value: APPROVAL_CATEGORY_CALL_AUDIO = 11;
     */
    ApprovalCategory[ApprovalCategory["CALL_AUDIO"] = 11] = "CALL_AUDIO";
    /**
     * @generated from enum value: APPROVAL_CATEGORY_OTHER = 12;
     */
    ApprovalCategory[ApprovalCategory["OTHER"] = 12] = "OTHER";
    /**
     * @generated from enum value: APPROVAL_CATEGORY_SCREEN_STREAM = 13;
     */
    ApprovalCategory[ApprovalCategory["SCREEN_STREAM"] = 13] = "SCREEN_STREAM";
})(ApprovalCategory || (ApprovalCategory = {}));
/**
 * Describes the enum fistos.v1.ApprovalCategory.
 */
export const ApprovalCategorySchema = /*@__PURE__*/ enumDesc(file_approval, 0);
